import { z } from 'zod';
import { IdZ, TsZ, textZ } from './common';

/**
 * One installed PWA holding a session token. The DB keeps HMAC(SESSION_SECRET, token)
 * only (R11). Cookie `__Host-tts` (`tts_dev` on http localhost).
 */
export const PlatformZ = z.enum(['ios', 'android', 'desktop', 'other']);
export type Platform = z.infer<typeof PlatformZ>;
export const DisplayModeZ = z.enum(['standalone', 'browser']);

export const DeviceZ = z.object({
  id: IdZ,
  memberId: IdZ,
  name: textZ(1, 60).nullable(),
  platform: PlatformZ,
  createdAt: TsZ,
  lastSeenAt: TsZ,
  /** True for the device making the request. */
  current: z.boolean(),
});
export type Device = z.infer<typeof DeviceZ>;

/** Header names. Every authenticated call sends both; the SW sends them too. */
export const DISPLAY_HEADER = 'X-TTS-Display';
export const CLIENT_HEADER = 'X-TTS-Client';
export const APP_VERSION_HEADER = 'X-App-Version';
export const SESSION_COOKIE = '__Host-tts';
export const SESSION_COOKIE_DEV = 'tts_dev';
export const PENDING_INVITE_COOKIE = 'tts_pending';
